<template>
	<div class="page-content users-table-view">
		<div class="container-fluid bracket-custom-style">
			<Affix :offset-top="0">
				<Card class="header-card">
					<Row>
						<Col span="16">
						<span class="page-title">{{ $t('menu.edit_competition') }}</span>
						</Col>
						<Col span="8" class="d-flex justify-content-end">
						<Button type="warning" class="md-checkmark-style" @click="onSaveCompetition('competitionFormEdited')">
							<b>{{ $t('menu.save_competition') }}</b>
						</Button>
						</Col>
					</Row>
				</Card>
			</Affix>
			<Spin v-if="loading" fix>
				<Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
				<div>{{ $t('global.loading') }}</div>
			</Spin>
			<Row v-else style="margin-top: 20px;">
				<Col span="24">
				<div style="padding-bottom: 50px;">
					<Row>
						<Form :model="formItem" ref="competitionFormEdited" label-position="top" :rules="ruleInline">
							<Col span="8">
							<Card style="max-width: 640px;">

								<FormItem :label="$t('competition.name')" prop="competitionName">
									<Input v-model="formItem.competitionName" placeholder="Introdu denumirea competitiei"></Input>
								</FormItem>

								<FormItem :label="$t('club.table.date')" prop="date">
									<DatePicker v-model="formItem.date" type="daterange" format="dd-MM-yyyy" split-panels
										placeholder="Select date" style="width: 200px;"></DatePicker>
								</FormItem>

								<FormItem :label="$t('competition.category')" prop="formats">
									<CheckboxGroup size="large" v-model="formItem.formats" @on-change="onSelectTeamCategories"
										class="d-flex flex-wrap justify-content-between">
										<Checkbox v-for="cat in teamCategories" :value="cat._id" :key="cat._id" :label="cat._id"
											class="category-checkbox">{{ cat.name }}</Checkbox>
									</CheckboxGroup>
								</FormItem>

								<FormItem :label="$t('competition.type')" prop="ttype">
									<!-- <Select v-model="formItem.selectTtypes" placeholder="Tip" @on-change="onSelectTtypes">
										<Option v-for="ttype in ttypes" :value="ttype._id" :key="ttype._id" :label="ttype.name"></Option>
									</Select> -->
									<RadioGroup v-model="formItem.selectTtypes" @on-change="onSelectTtypes"
										class="d-flex flex-wrap justify-content-between">
										<Radio v-for="ttype in ttypes" :value="ttype._id" :key="ttype._id" :label="ttype._id"
											class="ttypes-radio-style">
											{{ ttype.name }}
										</Radio>
									</RadioGroup>
								</FormItem>

								<FormItem :label="$t('user.responsible')">
									<Select v-model="formItem.selectResponsibile" :placeholder="$t('user.select_responsible')" filterable
										@on-change="onSelectResponsible">
										<Option value="none">{{ $t('user.responsible') }}</Option>
										<Option v-for="user in users" :value="user._id" :key="user._id" :label="user.name"></Option>
									</Select>
								</FormItem>

								<FormItem :label="$t('competition.reg_start')" prop="startRegDate">
									<CompetitionDateHour :data="startRegistered" :formItemDate="formItem.date"
										@onChangeDates="setStartDate('startRegistered', startRegistered)"
										@onChangeHours="setStartHour('startRegistered', startRegistered)" :valueTimePicker="valueTimePicker"
										:customKey="Date.now()" />
								</FormItem>

								<FormItem :label="$t('competition.reg_end')" prop="endRegDate">
									<CompetitionDateHour :data="endRegistered" :formItemDate="formItem.date"
										@onChangeDates="setStartDate('endRegistered', endRegistered)"
										@onChangeHours="setStartHour('endRegistered', endRegistered)" :valueTimePicker="valueTimePicker"
										:customKey="Date.now()" />
								</FormItem>
								<div class="d-flex align-items-center justify-content-between">
									<FormItem :label="$t('competition.top_stats')" prop="enableStats">
										<Checkbox label="stats" v-model="formItem.enableStats" class="category-checkbox"> {{ formItem.enableStats ? 'On' : 'Off' }} </Checkbox>
									</FormItem>
									<FormItem :label="$t('competition.late_reg')" prop="forceLateReg">
										<Checkbox label="force_reg" v-model="formItem.forceLateReg" class="category-checkbox"> {{ formItem.forceLateReg ? 'On' : 'Off' }} </Checkbox>
									</FormItem>
								</div>
								<!-- <FormItem v-if="ifTtypes" label="Etape">
									<InputNumber v-model="formItem.stage" :value="+0" :min="+0" style="margin-right: 5px; max-width: 78px;"
										placeholder="0"></InputNumber>
								</FormItem>

								<FormItem label="Data" v-if="stageCount.length > 0">
									<template v-for="(stage, idx) in stageCount">
										<div class="mb-3" :key="idx">
											<h5 class="mb-2">{{ selectedCompetition.stages[idx].name }}</h5>
											<CompetitionDateHour :data="stage" :valueTimePicker="valueTimePicker" :formItemDate="formItem.date"
												@onChangeDates="setStartDate('stage', stage, idx)"
												@onChangeHours="setStartHour('stage', stage, idx)" :customKey="Date.now()" :stageKey="'stage'" />
										</div>
									</template>
								</FormItem>

								<FormItem label="Teren" v-if="selectedCompetition && selectedCompetition.stages.length > 0">
									<div>
										<template v-for="(stage, idx) in selectedCompetition.stages">
											<div class="mb-3" :key="idx">
												<h5 class="mb-2">Teren {{ idx + 1 }}</h5>
												<div class="d-flex align-items-center">
													<Input v-model="stage.stadium" placeholder="Denumirea terenului" class="mr-3" />
													<InputNumber v-model="stage.spends" :value="+0" :min="+0"
														style="margin-right: 5px; max-width: 78px;" placeholder="0"></InputNumber>
													<span>{{$t('competition.lei')}}</span>
												</div>
											</div>
										</template>
									</div>
								</FormItem> -->

								<!-- <FormItem :label="$t('user.referee')">
									<Select v-model="formItem.selectReferee" :placeholder="$t('user.select_referee')"
										@on-change="onSelectReferee" style="width: 425px;" filterable clearable>
										<Option value="none">{{ $t('user.referee') }}</Option>
										<Option v-for="user in referee" :value="user._id" :disabled="true" :key="user._id"
											class="disabled-referee">
											<div class="d-flex align-items-center justify-content-between" style="100%">
												<span>
													<b>{{ user.firstName }} {{ user.secondName }}</b>
												</span>
												<Button @click="addReferee(user)" :disabled="user.selectedWithCompetition" type="success"
													icon="md-add"></Button>
											</div>
										</Option>
									</Select>

									<div v-if="selectedRefereeWithCompetiton.length > 0" class="mt-3">
										<template v-for="(selectedReferee, index) in selectedRefereeWithCompetiton">
											<div :key="selectedReferee._id" class="mb-2">
												<div class="d-flex align-items-center justify-content-between"
													style="width: 425px; padding: 3px 16px;">
													<span>
														<b>{{ selectedReferee.firstName }} {{ selectedReferee.secondName }}</b>
													</span>
													<div class="d-flex align-items-center">
														<InputNumber :key="selectedReferee._id" v-model="selectedReferee.spends" :value="+0" :min="+0"
															style="margin-right: 5px; max-width: 78px;" placeholder="0"></InputNumber>
														<span>{{$t('competition.lei')}}</span>
														<Button @click="removeReferee(selectedReferee, index)" class="ml-5" type="error"
															icon="md-trash"></Button>
													</div>
												</div>
											</div>
										</template>
									</div>
								</FormItem>

								<div class="d-flex">
									<FormItem label="Ambulanta" style="width: 50%;">
										<div class="d-flex align-items-center">
											<Checkbox v-model="formItem.ambulance.status">Ambulanta</Checkbox>

											<div v-if="formItem.ambulance.status" class="d-flex align-items-center ml-4">
												<InputNumber v-model="formItem.ambulance.spends" :value="+0" :min="+0"
													style="margin-right: 5px; max-width: 78px;" placeholder="0"></InputNumber>
												<span>{{$t('competition.lei')}}</span>
											</div>
										</div>
									</FormItem>

									<FormItem label="Medic" style="width: 50%;">
										<div class="d-flex align-items-center">
											<Checkbox v-model="formItem.medic.status">Medic</Checkbox>

											<div v-if="formItem.medic.status" class="d-flex align-items-center ml-4">
												<InputNumber v-model="formItem.medic.spends" :value="+0" :min="+0"
													style="margin-right: 5px; max-width: 78px;" placeholder="0"></InputNumber>
												<span>{{$t('competition.lei')}}</span>
											</div>
										</div>
									</FormItem>
								</div> -->

								<FormItem :label="$t('competition.regulations')" class="competition-tech-pass">
									<Card>
										<div slot="title">
											<Upload ref="upload" :action="api_domain + 'file/upload'" :show-upload-list="true"
												:on-success="handleSuccess" :format="['jpg', 'jpeg', 'png', 'pdf']"
												:on-format-error="handleFormatError" :before-upload="handleBeforeUpload" :on-remove="handleRemove"
												multiple type="drag">
												<div style="padding: 20px 0; width: 100%;">
													<Icon type="ios-cloud-upload" size="52" style="color: #3399ff;"></Icon>
													<p>Click or drag files here to upload</p>
												</div>
											</Upload>
										</div>
										<div v-if="uploadList && uploadList.length > 0" class="upload-file-list-block">
											<!-- <h6 class="mb-2">{{ $t('invoice.attachment') }}</h6> -->
											<a v-for="(att, key) in uploadList" :href="api_domain + att" class="mr-1 upload-file-list"
												target="_blank" :id="att">
												<i class="attachment bx bxs-file" style="font-size: 40px;"></i>
												<i class="bx bxs-trash" style="font-size: 15px; color: red;"
													@click="(res) => handleRemoveUploadList(res, key)"></i>
											</a>
										</div>
									</Card>
								</FormItem>

								<div>
									<Divider />
									<FormItem :label="$t('competition.notes')">
										<CompetitionFileTextComponent :compFileText="componentFileText" />
									</FormItem>
								</div>

								<div class="mb-3">
									<!-- <Row>
												<Col span="24">
													<Button type="success" size="large" long @click="addCustomNotice">Adauga un cimp nou informativ</Button>
												</Col>
											</Row> -->
									<div v-for="(item, idx) in formDynamicNotice" style="position: relative;">
										<div :key="Date.now()">
											<Divider />
											<FormItem :key="idx" :label="'Informatie ' + (idx + 1)">
												<Button @click="removeCustomNotice(idx)" class="d-flex align-items-center justify-content-center"
													type="error" style="position: absolute; top: -30px; right: 0;" icon="md-trash"></Button>
												<CompetitionFileTextComponent :compFileText="item" :customKey="Date.now()" />
											</FormItem>
										</div>
										<!-- <div v-else>
													{{ item }}
													<FormItem :key="idx" :label="'Informatie ' + (idx + 1)">
														<CompetitionFileTextComponent :compFileText="item" :customKey="item.toString()" />
													</FormItem>
												</div> -->
									</div>
								</div>

								<div>
									<div v-for="(item, idx) in formDynamicRent" style="position: relative;">
										<div :key="Date.now()">
											<Divider />
											<FormItem :key="idx" :label="$t('competition.spends') + ' ' + (idx + 1)">
												<Button @click="removeCustomRent(item, idx)"
													class="d-flex align-items-center justify-content-center" type="error"
													style="position: absolute; top: -30px; right: 0;" icon="md-trash"></Button>
												<CompetitionFileInputComponent :compFileText="item" :customKey="Date.now()" />
											</FormItem>
										</div>
										<!-- <div v-else>
													<FormItem :key="idx" :label="'Cheltuieli ' + (idx + 1)">
														<CompetitionFileInputComponent :compFileText="item" :customKey="item.toString()" />
													</FormItem>
												</div> -->
									</div>
								</div>

								<div>
									<Row>
										<Col span="24" class="mb-3">
										<Button type="success" size="large" long @click="addCustomNotice">{{ $t('competition.add_field')
										}}</Button>
										</Col>
										<Col span="24">
										<Button type="success" size="large" long @click="addCustomRent">{{ $t('competition.add_spends')
										}}</Button>
										</Col>
									</Row>
									<!-- <div v-for="(item, idx) in formDynamicRent" v-if="item.status" style="position: relative;">
												<Divider />
												<FormItem :key="idx" :label="'Cheltuieli ' + item.index">
													<Button
														@click="removeCustomRent(idx)"
														class="d-flex align-items-center justify-content-center"
														type="error"
														style="position: absolute; top: -30px; right: 0;"
														icon="md-trash"
													></Button>
													<CompetitionFileInputComponent :compFileText="item" />
												</FormItem>
											</div> -->
								</div>

							</Card>
							</Col>
							<Col span="13" offset="1">

							<div v-if="formItem.selectTtypes" class="mb-3" style="text-align: center">
								<ButtonGroup shape="circle" size="large" style="max-width: 200px">
									<Button type="primary" size="large" @click="() => { if (formItem.stage > 0) formItem.stage--; }"><i
											class='bx bx-minus wtf-icon'></i> </Button>
									<div class="etaps" size="large">{{ formItem.stage }}</div>
									<Button type="primary" size="large" @click="() => { formItem.stage++; }"><i
											class='bx bx-plus wtf-icon'></i> </Button>
								</ButtonGroup>
							</div>

							<!--                    <InputNumber v-model="formItem.stage" :max="maxStageNumber" :min="+0"-->
							<!--                                 placeholder="0" style="margin-right: 5px; max-width: 78px;"></InputNumber>-->
							<Row :gutter="20" type="flex" justify="center">
								<template v-for="(stage, idx) in stageCount">
									<Col>
									<Card class="mb-3">
										{{ $t('competition.stage') }}: {{ idx + 1 }}
										<FormItem v-if="stageCount.length > 0" :label="$t('club.table.date')" :prop="`stageDate${idx + 1}`">
											<CompetitionDateHour :customKey="Date.now()" :data="stage" :formItemDate="formItem.date"
												:stageKey="'stage'" :valueTimePicker="valueTimePicker"
												@onChangeDates="setStartDate('stage', stage, idx)"
												@onChangeHours="setStartHour('stage', stage, idx)" />

										</FormItem>
										<FormItem v-if="stageCount.length > 0" :label="$t('competition.field')">
											<div class="d-flex align-items-center">
												<Input v-model="stage.stadium" class="mr-3" placeholder="Denumirea terenului" />
												<InputNumber v-model="stage.spends" :min="+0" placeholder="0"
													style="margin-right: 5px; max-width: 78px;"></InputNumber>
												<span>{{ $t('competition.lei') }}</span>
											</div>
										</FormItem>
										<divider />
										<FormItem :label="$t('user.referee')">
											<Select v-model="formItem.selectReferee" :placeholder="$t('user.select_referee')" clearable
												filterable style="width: 425px;" @on-change="onSelectReferee">
												<Option value="none">{{ $t('user.referee') }}</Option>
												<Option v-for="item in referee" :key="item._id" :disabled="true" :value="item._id"
													class="disabled-referee">
													<div class="d-flex align-items-center justify-content-between" style="100%">
														<span>
															<b>{{ item.firstName }} {{ item.secondName }}</b>
														</span>
														<Button :disabled="stage.refereeInfo.findIndex(el => el.referee._id === item._id) >= 0"
															icon="md-add" type="success"
															@click="addReferee(JSON.parse(JSON.stringify(item)), idx)"></Button>
													</div>
												</Option>
											</Select>

											<div class="mt-3">
												<template v-for="(selectedReferee, index) in stage.refereeInfo">
													<div :key="selectedReferee.referee._id" class="mb-2">
														<div class="d-flex align-items-center justify-content-between"
															style="width: 425px; padding: 3px 16px;">
															<span>
																<b>{{ selectedReferee.referee.firstName }} {{ selectedReferee.referee.secondName }}</b>
															</span>
															<div class="d-flex align-items-center">
																<InputNumber :key="selectedReferee.referee._id" v-model="selectedReferee.spends" :min="+0"
																	:value="+0" placeholder="0" style="margin-right: 5px; max-width: 78px;"></InputNumber>
																<span>{{ $t('competition.lei') }}</span>
																<Button class="ml-5" icon="md-trash" type="error"
																	@click="removeReferee(selectedReferee, index, idx)"></Button>
															</div>
														</div>
													</div>
												</template>
											</div>
										</FormItem>

										<divider />
										<FormItem :label="$t('competition.spends')">
											<Row>
												<Col span="12" style="border-right: 1px solid #eee;padding-right: 10px;">
												<div class="d-flex align-items-center">
													<span style="width: 100%">{{ $t('competition.medic') }}</span>
													<InputNumber size="small" v-model="stage.spends_medic" :min="+0" :value="+0" placeholder="0"
														style="margin-right: 5px; max-width: 78px;"></InputNumber>
													<span>{{ $t('competition.lei') }}</span>
												</div>
												<div class="d-flex align-items-center">
													<span style="width: 100%">{{ $t('competition.ambulance') }}</span>
													<InputNumber size="small" v-model="stage.spends_ambulance" :min="+0" :value="+0" placeholder="0"
														style="margin-right: 5px; max-width: 78px;"></InputNumber>
													<span>{{ $t('competition.lei') }}</span>
												</div>
												<div class="d-flex align-items-center">
													<span style="width: 100%">{{ $t('competition.prize') }}</span>
													<InputNumber size="small" v-model="stage.spends_cups" :min="+0" :value="+0" placeholder="0"
														style="margin-right: 5px; max-width: 78px;"></InputNumber>
													<span>{{ $t('competition.lei') }}</span>
												</div>
												<div class="d-flex align-items-center">
													<span style="width: 100%">{{ $t('competition.water') }}</span>
													<InputNumber size="small" v-model="stage.spends_water" :min="+0" :value="+0" placeholder="0"
														style="margin-right: 5px; max-width: 78px;"></InputNumber>
													<span>{{ $t('competition.lei') }}</span>
												</div>
												</Col>
												<Col span="12" class="pl-1">
												<div class="d-flex align-items-center">
													<span style="width: 100%">{{ $t('competition.food') }}</span>
													<InputNumber size="small" v-model="stage.spends_food" :min="+0" :value="+0" placeholder="0"
														style="margin-right: 5px; max-width: 78px;"></InputNumber>
													<span>{{ $t('competition.lei') }}</span>
												</div>
												<div class="d-flex align-items-center">
													<span style="width: 100%">{{ $t('competition.transport') }}</span>
													<InputNumber size="small" v-model="stage.spends_transport" :min="+0" :value="+0" placeholder="0"
														style="margin-right: 5px; max-width: 78px;"></InputNumber>
													<span>{{ $t('competition.lei') }}</span>
												</div>
												<div class="d-flex align-items-center">
													<span style="width: 100%">{{ $t('competition.others') }}... </span>
													<InputNumber size="small" v-model="stage.spends_other" :min="+0" :value="+0" placeholder="0"
														style="margin-right: 5px; max-width: 78px;"></InputNumber>
													<span>{{ $t('competition.lei') }}</span>
												</div>
												</Col>
											</Row>


										</FormItem>
									</Card>
									</Col>
								</template>
							</Row>


							</Col>
						</Form>
					</Row>
				</div>
				</Col>
			</Row>

			<!-- <Card>
				<div class="d-flex justify-content-between align-items-center">
					<div>
						<span v-if="arrayFiltered.length">
							{{ $t('global.entries') }}
							{{ getPageLabel(arrayList.total, parseInt(tableLenght), arrayList.page - 1) }}
							{{ $t('global.of') }} {{ arrayFiltered.length }} {{ $t('global.entry') }} ({{ $t('global.filtered', { len: array.length }) }})
						</span>
						<span v-else>
							{{ $t('global.entries') }}
							{{ getPageLabel(arrayList.total, parseInt(tableLenght), arrayList.page - 1) }}
							{{ $t('global.of') }} {{ array.length }}
							{{ $t('global.entry') }}
						</span>
					</div>
					<Page @on-change="changePage" v-if="arrayList.total > 0" :current="arrayList.page" :page-size="parseInt(tableLenght)" :total="arrayList.total" />
				</div>
			</Card> -->
		</div>
	</div>
</template>
<script>
import mixin from '../mixinTable';
import CompetitionDateHour from './utils/CompetitionDateHour';
import CompetitionFileTextComponent from './utils/CompetitionFileTextComponent';
import CompetitionFileInputComponent from './utils/CompetitionFileInputComponent';

export default {
	name: 'EditCompetition',
	components: { CompetitionDateHour, CompetitionFileTextComponent, CompetitionFileInputComponent },
	mixins: [mixin],
	data() {
		const validateDate = (rule, value, callback) => {
			const validField = value.filter((item) => item !== '');

			if (validField.length <= 0) {
				callback(new Error('Please fill in the date'));
			} else {
				return callback();
			}
		};
		const validateTtype = (rule, value, callback) => {
			value = this.ifSelectedTtype;

			if (this.selectedCompetition) {
				callback();
			}

			if (value.length <= 0) {
				callback(new Error('Please fill in the type'));
			} else {
				callback();
			}
		};
		const validateStartRegistered = (rule, value, callback) => {
			if (this.startRegistered.startDate.length <= 0) {
				callback(new Error('Please fill in the Start registered date'));
			} else if (this.startRegistered.startHour.length <= 0) {
				callback(new Error('Please fill in the Start registered hour'));
			} else {
				callback();
			}
		};
		const validateEndRegistered = (rule, value, callback) => {
			if (this.endRegistered.startDate.length <= 0) {
				callback(new Error('Please fill in the End registered date'));
			} else if (this.endRegistered.startHour.length <= 0) {
				callback(new Error('Please fill in the End registered hour'));
			} else {
				callback();
			}
		};
		return {
			loading: false,
			ifTtypes: false,
			uploadList: null,
			errorFile: null,
			formItem: {
				competitionName: '',
				selectTtypes: '',
				selectResponsibile: null,
				// selectReferee: [],
				formats: [],
				date: [],
				stage: 0,
				enableStats: false,
				forceLateReg: false,
				// medic: {
				// 	status: false,
				// 	spends: 0,
				// },
				// ambulance: {
				// 	status: false,
				// 	spends: 0,
				// },
				regulations: [],
			},
			teamCategories: [],
			ttypes: [],
			ifSelectedTtype: '',
			users: [],
			referee: [],
			selectedRefereeWithCompetiton: [],
			valueTimePicker: ['Hour', 'Minutes'],
			stageCount: [],
			hourDisabled: true,
			startRegistered: {
				startDate: '',
				startHour: '',
			},
			endRegistered: {
				startDate: '',
				startHour: '',
			},
			index: 0,
			formDynamicNotice: [],
			formDynamicRent: [],
			componentFileText: {
				noticeUploadList: [],
				imgName: '',
				visibleNoticeModal: false,
				valueNotice: '',
			},
			aditionalInfo: {
				noticeUploadList: [],
				imgName: '',
				visibleNoticeModal: false,
				valueNotice: '',
			},
			aditionalSpents: {
				rentUploadList: [],
				imgName: '',
				visibleRentModal: false,
				valueRent: '',
			},
			competitionId: null,
			selectedCompetition: null,
			savedCompStages: [],
			ruleInline: {
				competitionName: [{ required: true, message: 'Please fill in the Competition name', trigger: 'blur' }],
				date: [{ required: true, validator: validateDate, trigger: 'blur' }],
				formats: [{ required: true, type: 'array', min: 1, message: 'Please choose at least one formats', trigger: 'change' }],
				ttype: [{ required: true, validator: validateTtype, trigger: 'change' }],
				startRegDate: [{ required: true, validator: validateStartRegistered, trigger: 'change' }],
				endRegDate: [{ required: true, validator: validateEndRegistered, trigger: 'change' }],
			},
		};
	},
	watch: {
		formItem: {
			deep: true,
			handler(_n) {
				this.changes = true
				console.log("_n", this.changes);
				console.log("comp", this.selectedCompetition);
			}
		},
		'formItem.stage'(n, o) {
			if (n > o) {
				this.ruleInline['stageDate' + (parseInt(n) + 1)] = [{ required: true, validator: this.specialValidateStartRegistered, trigger: 'change' }]
				if (this.selectedCompetition) {
					this.filterStagesByCategory(this.selectedCompetition)
					this.savedCompStages = [...JSON.parse(JSON.stringify(this.selectedCompetition.displayStages))]
				}
				let int = this.savedCompStages.length;
				let initiator = this.stageCount.length
				console.log("int, n, o", int, n, o)
				console.log("selectedCompetition 22222", this.selectedCompetition)

				

				console.log("savedCompStages", this.savedCompStages)

				const aditionalStage = {
					name: 'Etapa ' + n,
					date_start: '',
					date_end: '',
					stadium: '',
					spends: 0,
					refereeInfo: [],
					spends_medic: 0,
					spends_ambulance: 0,
					spends_cups: 0,
					spends_water: 0,
					spends_food: 0,
					spends_transport: 0,
					spends_other: 0,
					isCurrent: false,
				};
				console.log({initiator, int});
				for (let i = initiator; i < int; i++) {
					const stageDateObj = {
						name: this.selectedCompetition.stages[i].name,
						date_start: this.selectedCompetition.stages[i].date_start,
						date_end: '',
						stadium: this.selectedCompetition.stages[i].stadium,
						spends: this.selectedCompetition.stages[i].spends,
						refereeInfo: this.selectedCompetition.stages[i].refereeInfo,
						spends_medic: this.selectedCompetition.stages[i].spends_medic,
						spends_ambulance: this.selectedCompetition.stages[i].spends_ambulance,
						spends_cups: this.selectedCompetition.stages[i].spends_cups,
						spends_water: this.selectedCompetition.stages[i].spends_water,
						spends_food: this.selectedCompetition.stages[i].spends_food,
						spends_transport: this.selectedCompetition.stages[i].spends_transport,
						spends_other: this.selectedCompetition.stages[i].spends_other,
						isCurrent: this.selectedCompetition.stages[i].isCurrent,
					};
					this.stageCount.push({ ...stageDateObj });
				}


				if (n > int) {
					this.stageCount.push({ ...aditionalStage });
				}
			} else {
				let int = o - n;
				for (let i = 0; i < int; i++) {
					this.stageCount.pop();
				}
				// this.selectedCompetition.stages.pop();
			}
		},
		// 'formItem.ambulance.status'(value) {
		// 	if (value === false) {
		// 		this.formItem.ambulance.spends = 0;
		// 	}
		// },
		// 'formItem.medic.status'(value) {
		// 	if (value === false) {
		// 		this.formItem.medic.spends = 0;
		// 	}
		// },
		// 'startRegistered.startDate'(n, o) {
		// 	console.log('startRegistered startDate', n, o);
		// },
		// 'startRegistered.startHour'(n, o) {
		// 	console.log('startRegistered startHour', n, o);
		// },
		// stageCount() {
		// 	console.log('stageCount', this.stageCount);
		// },
	},
	methods: {
		filterStagesByCategory(object) {
				const grouped = object.stages.reduce((acc, obj) => {
        const category = obj.category;
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(obj);
        return acc;
      }, {});
			console.log(grouped);

      const maxCategory = Object.keys(grouped).reduce((a, b) =>
        grouped[a].length >= grouped[b].length ? a : b
      );

      object.displayStages = grouped[maxCategory];
    },
		specialValidateStartRegistered(rule, value, callback) {
			console.log(rule.field.slice(-1));
			if (this.stageCount[parseInt(rule.field.slice(-1)) - 1].date_start) {
				callback();
			} else {
				callback(new Error('Please fill in the Start registered hour'));
			}
		},
		removeCustomNotice(idx) {
			this.index--;
			this.formDynamicNotice[idx].status = 0;
			this.formDynamicNotice[idx].index = this.index;
			this.formDynamicNotice.splice(idx, 1);
		},
		addCustomNotice() {
			this.index++;
			this.formDynamicNotice.push({
				value: '',
				index: this.index,
				status: 1,
				...JSON.parse(JSON.stringify(this.aditionalInfo)),
			});
		},
		removeCustomRent(item, idx) {
			console.log('item', item);
			this.index--;
			this.formDynamicRent[idx].status = 0;
			this.formDynamicRent[idx].index = this.index;
			this.formDynamicRent.splice(idx, 1);
		},
		addCustomRent() {
			this.index++;
			this.formDynamicRent.push({
				value: '',
				index: this.index,
				status: 1,
				...JSON.parse(JSON.stringify(this.aditionalSpents)),
			});
		},
		handleBeforeUpload() {
			this.errorFile = null;
			return true;
		},
		handleFormatError(error, file, fileList) {
			this.errorFile = {
				file,
				fileList,
			};
			this.$Notice.warning({
				title: file,
				desc: 'File format of ' + fileList.name + ' is incorrect, please select jpg, png or pdf',
			});
		},
		handleRemove(res, file) {
			this.formItem.regulations.splice(res, 1);
		},
		handleSuccess(res, file) {
			this.formItem.regulations.push(res.path);
		},
		handleRemoveUploadList(res, key) {
			res.preventDefault();
			this.formItem.regulations.splice(key, 1);
			this.uploadList.splice(key, 1);
		},
		removeReferee(user, index, idx) {
			console.log(user, index, idx);
			user.selectedWithCompetition = -1;
			this.stageCount[idx].refereeInfo.splice(index, 1);
		},
		addReferee(user, idx) {
			console.log(user, idx);
			user.selectedWithCompetition = idx;
			this.stageCount[idx].refereeInfo.push({ referee: user, spends: 0 });
		},
		onSaveCompetition(name) {
			console.log('Click onSaveCompetition');

			const {
				competitionName,
				selectTtypes,
				selectResponsibile,
				// selectReferee,
				formats,
				date,
				stage,
				enableStats,
				forceLateReg,
				// medic,
				// ambulance,
				regulations,
				...other
			} = this.formItem;

			let stageDateObj = {
				name: 'Etapa 1',
				date_start: new Date(),
				date_end: '',
				stadium: '',
				spends: 0,
				refereeInfo: [],
				spends_medic: 0,
				spends_ambulance: 0,
				spends_cups: 0,
				spends_water: 0,
				spends_food: 0,
				spends_transport: 0,
				spends_other: 0,
				isCurrent: true
			};

			let responsible;

			if (selectResponsibile === 'none' || selectResponsibile === '') {
				responsible = null;
			} else {
				responsible = selectResponsibile;
			}
			const competition = {
				name: competitionName,
				date: date,
				formats: this.selectedCompetition.formats.map(({ category, ...rest }) => {
					return {
						category: typeof category === 'object' ? category._id : category,
						...rest
					}
				}),
				ttype: selectTtypes,
				responsible: responsible,
				enableStats: enableStats,
				forceLateReg: forceLateReg,
				stages: this.stageCount.length > 0 ? [...this.stageCount] : [stageDateObj],
				reg_date: [this.startRegistered.startDate, this.endRegistered.startDate],
				// refereeInfo: this.selectedRefereeWithCompetiton.map((item) => {
				// 	return {
				// 		referee: item._id,
				// 		spends: item.spends,
				// 	};
				// }),
				// fieldInfo: {
				// 	field: '',
				// 	spends: '',
				// },
				// ambulance: {
				// 	status: ambulance.status,
				// 	spends: ambulance.spends,
				// },
				// medic: {
				// 	status: medic.status,
				// 	spends: medic.spends,
				// },
				regulations: regulations,
				notes: {
					text: this.componentFileText.valueNotice,
					files: this.componentFileText.noticeUploadList,
				},


				additional_info: this.formDynamicNotice.map((item) => {
					return {
						text: item.valueNotice,
						files: item.noticeUploadList,
					};
				}),
				additional_spends: this.formDynamicRent.map((item) => {
					return {
						text: item.valueRent,
						files: item.rentUploadList,
						spends: item.priceRent,
					};
				}),
				_id: this.competitionId,
			};
			competition.stages = competition.stages.map((stage)=>{
				var isoDateString = stage.startDate; 

				var hoursString = stage.startHour; 
				var date = new Date(isoDateString);
				var [hours, minutes] = hoursString.split(':').map(Number);

				date.setHours(hours);
				date.setMinutes(minutes);

				var formattedDate = date.toISOString();
				return{...stage, date_start: formattedDate }
			})

			const updatedStages = []
			if(competition.formats.length > 1 && competition.stages.some((stage)=>stage.category)){
				let actualStages = this.selectedCompetition.stages
				for (let i = 0; i < competition.stages.length; i++) {
					const element = competition.stages[i];
					let currentStages = actualStages.filter((stage)=>stage.name === element.name).map(({_id, category, rounds, isCurrent})=> {
						return{
							...element,
							_id,
							category,
							rounds,
							isCurrent
						}
					})
					console.log({currentStages});
					updatedStages.push(...currentStages)
				}
			}
			if(updatedStages.length)
				competition.stages = updatedStages
			// console.log('competition', competition);

			this.$refs[name].validate((valid) => {
				if (valid) {
					// this.loading = true;
					console.log(competition);
					this.onEditCompetition(competition);
				} else {
					this.$Message.error(this.$t('global.error'));
				}
			});
		},
		onSelectTtypes(value) {
			this.ifSelectedTtype = value;
			const selectTtypes = this.ttypes.find((item) => item._id === value);

			if (selectTtypes.name.includes('12') || selectTtypes.name.includes('15')) {
				this.selectedCompetition.stages = []
				this.formItem.stage = 0;
				this.ifTtypes = false;
			} else {
				this.selectedCompetition.stages = [...this.savedCompStages]
				this.formItem.stage = this.savedCompStages.length;
				this.ifTtypes = true;
			}

		},
		onSelectTeamCategories(value) {
			console.log('onSelectTeamCategories', value);
			if (value.length < this.selectedCompetition.formats.length) {
				this.selectedCompetition.formats = this.selectedCompetition.formats.filter((format) => value.some((val) => val === format.category._id))
				console.log(this.selectedCompetition.formats);
			} else if (value.length > this.selectedCompetition.formats.length) {
				this.selectedCompetition.formats.push({ category: value.find((val) => !this.selectedCompetition.formats.some((format) => format.category._id === val || format.category === val)) })
			}
		},
		onSelectResponsible(value) {
			console.log('onSelectResponsible', value);
		},
		onSelectReferee(value) {
			console.log('onSelectReferee', value);
		},
		setStartDate(key, stage, index) {
			if (key === 'stage') {
				if (stage.startDate) {
					if (!this.endRegistered.startDate) {
						const dates1 = new Date(stage.startDate);
						const dates2 = new Date(dates1.setDate(dates1.getDate() - 2));
						this.endRegistered.startDate = dates2;
					}
				}
				this.stageCount[index].date_start = stage.startDate;
				if (this.selectedCompetition.stages[index])
					this.selectedCompetition.stages[index].date_start = stage.startDate;
			}
		},
		setStartHour(key, stage, index) {
			if (stage) {
				const hours = stage.startHour.split(':');
				if (stage.startDate) {
					stage.startDate.setHours(hours[0], hours[1]);
				}

				console.log('stage', key, stage, index);

				if (key === 'stage') {
					if (index === 0) {
						this.endRegistered.startDate.setHours(hours[0], hours[1]);
						this.endRegistered.startHour = stage.startHour;
					}

					if (stage.date_start) {
						stage.date_start = this.endRegistered.startDate;
						// const dateEnd = new Date(stage.date_start);
						// let endtHour = dateEnd.getHours();
						// let endMinutes = dateEnd.getMinutes();

						// this.endRegistered = {
						// 	startDate: dateEnd,
						// 	startHour: endtHour + ':' + endMinutes,
						// };

						// const dateStart = new Date(stage.date_start);
						// let startHours = dateStart.getHours();
						// let startMinutes = dateStart.getMinutes();

						// stage.startDate = new Date(stage.date_start);
						// stage.startHour = startHours + ':' + startMinutes;
					}
				}
			}
		},
		async onEditCompetition(competition) {
			console.log('onEditCompetition', competition);
			this.loading = true;
			try {
				await this.$http.post('/competition/editNew', competition).then(async(response) => {
					await this.getOneCompetition()
					this.$Message.success({
						content: this.$t('global.saved'),
						duration: 2,
					});
					setTimeout(() => {
						this.changes = false
						this.loading = false;
					}, 2000);
				});
			} catch (err) {
				this.$Message.error({
					content: this.$t('global.error'),
					duration: 2,
				});
				setTimeout(() => {
					this.loading = false;
				}, 2000);
				console.log('Error', 'Something Went Wrong', err);
			}
		},
		async getTeamCategories() {
			try {
				await this.$http
					.post('/competition/category/list')
					.then((response) => {
						this.teamCategories = response.data;
					})
					.catch((error) => console.log('Error getTeamCategories', error));
			} catch (err) {
				console.log('Error', 'Something Went Wrong', err);
			}
		},
		async getTtypes() {
			try {
				await this.$http
					.post('/competition/ttype/list')
					.then((response) => {
						this.ttypes = response.data.sort((a, b) => a.sort_count - b.sort_count);
					})
					.catch((error) => console.log('Error getTtypes', error));
			} catch (err) {
				console.log('Error', 'Something Went Wrong', err);
			}
		},
		async getUsers() {
			try {
				await this.$http
					.get('/user')
					.then((response) => {
						this.users = response.data.users;
					})
					.catch((error) => console.log('Error getUsers', error));
			} catch (err) {
				console.log('Error', 'Something Went Wrong', err);
			}
		},
		async getReferee() {
			const refereeId = ['642d3502a76384148ef547ea', '642d34faa76384148ef547e5', '642d34f2a76384148ef547df'];
			try {
				await this.$http
					.post('/license/list', { categoryId: refereeId })
					.then((response) => {
						const resp = response.data;

						resp.forEach((item) => {
							let items = { ...item };
							items.selectedWithCompetition = false;
							items.spends = 0;
							this.referee.push(items);
						});

					})
					.catch((error) => console.log('Error getReferee', error));
			} catch (err) {
				console.log('Error', 'Something Went Wrong', err);
			}
		},

		async getOneCompetition() {
			try {
				if (this.competitionId) {
					await this.$http
						.post('/competition/find/', { _id: this.competitionId })
						.then((response) => {
							let selComp = response.data;
							console.log('selComp', selComp);
							this.selectedCompetition = this.generateData(selComp);
							console.log(this.referee);
							console.log('this.selectedCompetition', this.selectedCompetition);
						})
						.catch((error) => console.log('Error getOneCompetition', error));
				}
			} catch (err) {
				console.log('Error', 'Something Went Wrong', err);
			}
		},
		generateData(competition) {
			if (competition) {
				const ttypeId = this.ttypes.find((item) => item._id === competition.ttype._id);

				if (competition.ttype.name.includes('12') || competition.ttype.name.includes('15')) {
					this.ifTtypes = false;
				} else {
					this.ifTtypes = true;
				}

				this.filterStagesByCategory(competition)

				for (let i = 0; i < competition.displayStages.length; i++) {
					const compStages = competition.displayStages[i];
					compStages.spends = Number(compStages.spends);
				}

				this.formItem = {
					competitionName: competition.name,
					selectTtypes: ttypeId._id,
					selectResponsibile: competition.responsible._id,
					// selectReferee: competition.refereeInfo,
					formats: competition.formats.map((item) => item.category._id),
					enableStats: competition.enableStats,
					forceLateReg: competition.forceLateReg,
					date: competition.date.map((item) => new Date(item)),
					stage: competition.displayStages.length > 0 ? competition.displayStages.length : 0,
					// medic: {
					// 	spends: Number(competition.medic.spends),
					// 	status: competition.medic.status,
					// },
					// ambulance: {
					// 	spends: Number(competition.ambulance.spends),
					// 	status: competition.ambulance.status,
					// },
					regulations: [...competition.regulations],
				};
				this.stageCount = competition.displayStages

				console.log("FORMITEM", this.formItem);

				const dateStart = new Date(competition.reg_date[0]);
				let startHour = dateStart.getHours();
				let startMinutes = dateStart.getMinutes();

				this.startRegistered = {
					startDate: dateStart,
					startHour: startHour + ':' + startMinutes,
				};

				const dateEnd = new Date(competition.reg_date[1]);
				let endtHour = dateEnd.getHours();
				let endMinutes = dateEnd.getMinutes();

				this.endRegistered = {
					startDate: dateEnd,
					startHour: endtHour + ':' + endMinutes,
				};

				this.uploadList = competition.regulations.map((item) => item);

				// this.selectedRefereeWithCompetiton = competition.refereeInfo.map((item) => {
				// 	const { spends, referee, other } = item;
				// 	let refer = {
				// 		spends: Number(spends),
				// 		...referee,
				// 		...other,
				// 	};
				// 	return { ...refer };
				// });

				this.componentFileText = {
					noticeUploadList: [...competition.notes.files],
					valueNotice: competition.notes.text,
					imgName: [...competition.notes.files],
					visibleNoticeModal: false,
				};

				if (competition.additional_info.length > 0) {
					for (let item of competition.additional_info) {
						let ifDynamicNotice = {
							noticeUploadList: item.files.map((el) => el),
							valueNotice: item.text,
							imgName: item.files.map((el) => el),
							visibleNoticeModal: false,
						};

						this.formDynamicNotice = [...this.formDynamicNotice, { ...JSON.parse(JSON.stringify(ifDynamicNotice)) }];
					}
				}

				console.log('formDynamicNotice', this.formDynamicNotice);

				if (competition.additional_spends.length > 0) {
					for (let item of competition.additional_spends) {
						let ifDynamicRent = {
							rentUploadList: item.files.map((el) => el),
							valueRent: item.text,
							priceRent: parseInt(item.spends),
							imgName: item.files.map((el) => el),
							visibleRentModal: false,
						};

						this.formDynamicRent = [...this.formDynamicRent, { ...JSON.parse(JSON.stringify(ifDynamicRent)) }];
					}
				}

				console.log('formDynamicRent', this.formDynamicRent);
			}
			return competition;
		},
	},
	beforeRouteLeave(_to, _from, next) {
		if (this.changes === true) {
			this.$dialog
				.confirm(
					this.$t('global.nonSaveConfirm'),
					{
						okText: this.$t("global.yes"),
						cancelText: this.$t("global.no"),
						html: true,
						customClass: 'mahnung-confirm',
					}
				).then(async (_dialog) => {
					next();
				}).catch((_error) => {
					next(false);
				});
		} else { next(); }
	},
	mounted: async function () {
		this.loading = true;
		await this.getTeamCategories();
		await this.getTtypes();
		await this.getUsers();
		await this.getReferee();

		this.competitionId = this.$route.params.id;
		await this.getOneCompetition();

		// if (!this.selectedCompetition) return;
		setTimeout(() => { this.changes = false }, 0)

		setTimeout(() => { this.loading = false }, 1000)
	},
};
</script>
<style scoped>
.bracket-custom-style .ivu-spin {
	background: #454751 !important;
	color: #ffffff;
	z-index: 999;
}

.users-table-view .header-card {
	background: var(--bg-darkness);
	color: var(--text-color);
}

.users-table-view .page-title {
	font-size: 24px;
	font-weight: 600;
}

.users-table-view .table-striped tbody tr:nth-of-type(odd) {
	background-color: #e8e8e8;
}

.users-table-view :global(.ivu-select-selection .ivu-select-placeholder) {
	color: #495057;
}

.users-table-view .table tbody tr:hover,
.users-table-view .table-striped tbody tr:nth-of-type(odd):hover {
	background: #d3d3d3;
}

.competition-tech-pass :global(.ivu-form-item-content .ivu-upload) {
	width: 100%;
}

.upload-file-list {
	position: relative;
	display: inline-block;
}

.upload-file-list .bxs-trash {
	position: absolute;
	top: -5px;
	right: -2px;
	display: none;
	opacity: 0.8;
}

.upload-file-list .bxs-trash:hover {
	opacity: 1;
}

.upload-file-list:hover .bxs-trash {
	display: inline-block;
}

.competition-tech-pass :global(.ivu-card-head) {
	border-bottom: none;
}

.competition-tech-pass :global(.ivu-card-body) {
	padding: 0;
}

.upload-file-list-block {
	padding: 16px;
	border-top: 1px solid #e8eaec;
}

.competition-tech-pass :global(.ivu-upload-list .ivu-upload-list-file) {
	display: flex;
	align-items: center;
}

.competition-tech-pass :global(.ivu-upload-list .ivu-upload-list-file > span) {
	text-overflow: ellipsis;
	overflow: hidden;
	width: 244px;
	position: relative;
	padding-left: 17px;
	display: block;
}

.competition-tech-pass :global(.ivu-upload-list .ivu-upload-list-file > span > i) {
	position: absolute;
	left: 0;
}

.competition-tech-pass :global(.ivu-upload-list .ivu-upload-list-file) {
	justify-content: space-between !important;
}

.disabled-referee.ivu-select-item-disabled {
	cursor: default !important;
}

.disabled-referee.ivu-select-item-disabled:hover {
	background: #f3f3f3 !important;
}

.disabled-referee.ivu-select-item-disabled span>b {
	color: #515a6e !important;
}

.demo-spin-icon-load {
	animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
	from {
		transform: rotate(0deg);
	}

	50% {
		transform: rotate(180deg);
	}

	to {
		transform: rotate(360deg);
	}
}

.ttypes-radio-style.ivu-radio-wrapper,
.category-checkbox {
	margin: 0 4px 8px 4px;
	width: 75px;
	height: 50px;
	padding: 5px;
	background: #f3f3f3;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	overflow: hidden;
	font-size: 13px;
}

.ttypes-radio-style:hover,
.category-checkbox:hover {
	background: #e4e4e4;
}

.ttypes-radio-style.ivu-radio-wrapper {
	text-wrap: wrap;
	line-height: 1;
	text-align: center;
}

.ttypes-radio-style :global(.ivu-radio),
.category-checkbox :global(.ivu-checkbox) {
	display: none !important;
	position: absolute;
	top: -25px;
	left: -25px;
	transform: rotate(45deg);
}

.ttypes-radio-style :global(.ivu-radio .ivu-radio-inner),
.category-checkbox :global(.ivu-checkbox .ivu-checkbox-inner) {
	border-radius: 0;
	width: 42px;
	height: 42px;
	background: #5ABB73;
	border-color: #5ABB73;
}

.ttypes-radio-style :global(.ivu-radio .ivu-radio-inner:after),
.category-checkbox :global(.ivu-checkbox .ivu-checkbox-inner:after) {
	top: auto;
	left: auto;
	bottom: 15px;
	right: 2px;
	transform: rotate(0deg);
	width: 7px;
	height: 13px;
	border: 3px solid #ffffff;
	border-top: 0;
	border-left: 0;
}

.ttypes-radio-style :global(.ivu-radio .ivu-radio-inner:after) {
	border-radius: 0;
	background: none;
}

.ttypes-radio-style.ivu-radio-wrapper-checked,
.category-checkbox.ivu-checkbox-wrapper-checked {
	border: 3px solid #5ABB73;
}

.ttypes-radio-style.ivu-radio-wrapper-checked :global(.ivu-radio),
.category-checkbox.ivu-checkbox-wrapper-checked :global(.ivu-checkbox) {
	display: inline-block !important;
}

.wtf-icon {
	font-size: 20px;
	padding-top: 1px;
}

.etaps {
	background: white;
	position: relative;
	float: left;
	width: 50px;
	height: 35px;
	display: flex;
	text-align: center;
	flex-direction: row;
	align-content: center;
	align-items: center;
	justify-content: center;
	font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/EditCompetition.vue